<template>
  <div class="gr-root">
    <section id="home">
      <HomeHero />
    </section>

    <AboutUs />
    <OurAdvantages />
    <OurWork />
    <FinishedActivities />

    <!-- Persistent anchor wrapper. Spec 003 §5.6 requires
             `#dokumentasi-kegiatan` to exist even when the documentation child
             renders nothing, so the one documentation CTA always has a target
             on a cold native load. -->
    <div id="dokumentasi-kegiatan">
      <DocumentationPreview />
    </div>

    <FooterCta />
  </div>
</template>

<script lang="ts" setup>
// The masthead and the hero are imported eagerly. Spec 002 criterion 16
// requires the first banner's URL to be in the server-rendered document, so the
// hero is never wrapped in v-lazy, an async component, or ClientOnly.
import HomeHero from "@/features/home/views/components/HomeHero.vue";

// The remaining sections are code-split but still server-rendered, so all copy
// is present in the initial HTML.
const AboutUs = defineAsyncComponent(
  () => import("@/features/home/views/components/AboutUs.vue"),
);
const OurAdvantages = defineAsyncComponent(
  () => import("@/features/home/views/components/OurAdvantages.vue"),
);
const OurWork = defineAsyncComponent(
  () => import("@/features/home/views/components/OurWork.vue"),
);
const FinishedActivities = defineAsyncComponent(
  () => import("@/features/home/views/components/FinishedActivities.vue"),
);
const DocumentationPreview = defineAsyncComponent(
  () => import("@/features/home/views/components/DocumentationPreview.vue"),
);
const FooterCta = defineAsyncComponent(
  () => import("@/features/home/views/components/FooterCta.vue"),
);
</script>
